import sentry from '@gifsa/core/plugins/sentry/setup'

export default defineNuxtPlugin({
  name: 'sentry',
  setup({ vueApp }) {
    sentry(vueApp)
  },
})
